import Comissions from './Comissions';

export default Comissions;